import React from "react";

import NotFoundImage from "../../assets/404-Graphic.svg";

const NotFound = () => {
  return (
    <div className="section">
      <div className="container _404 flex px-8 gap-20 max-md:flex-col items-center justify-center h-[66vh]">
        <img src={NotFoundImage} alt="404 Error" />
        <div className="wrapper--404-texts">
          <h1 className="text-4xl font-bold">
            Page
            <br />
            coming soon...
          </h1>
          <br />
          <p className="text-lg">
            Please check back later, we are working on this page.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
